import React, { useLayoutEffect, useRef, useState, useEffect } from 'react';
import CircularLoader from "./CircularLoader";

const MathJaxHTMLContent = props => {
    const {ElementTag = 'div', html = undefined, disableInputs = false, refCallBack, showLoader = true, onChange, onKeyUp, ...rest} = props,
        divRef = useRef(),
        [isError, setError] = useState(false),
        [isProcessed, setProcessed] = useState(false),
        [isLoading, setLoading] = useState(showLoader);

    useLayoutEffect(() => {
        if (html != undefined && html !== '' && divRef.current != undefined && divRef.current !== '') {
            try {
                // disable inputs for test preview
                if(disableInputs){
                    const inputs = divRef.current.querySelectorAll('input, textarea, select, button');
                    inputs.forEach(input => {
                        input.disabled = true;
                    });
                }

                MathJax.typesetPromise([divRef.current]).then(() => {
                    setLoading(false);
                    //used to perform updates on the ref once it has been rendered
                    if (!isProcessed && refCallBack != undefined && typeof refCallBack === 'function') {
                        refCallBack(divRef.current);
                    }
                    setProcessed(true);
                });
            } catch (error) {
                setError(true);
                setLoading(false);
            }
        }
    },[html, divRef.current]);

    useEffect(() => {
        const container = divRef.current;

        const handleChange = (event) => onChange?.(event);
        const handleKeyUp = (event) => onKeyUp?.(event);

        if (container) {
            if (typeof onChange === 'function') {
                container.addEventListener('change', handleChange);
            }
            if (typeof onKeyUp === 'function') {
                container.addEventListener('keyup', handleKeyUp);
            }
        }

        return () => {
            if (container) {
                if (typeof onChange === 'function') {
                    container.removeEventListener('change', handleChange);
                }
                if (typeof onKeyUp === 'function') {
                    container.removeEventListener('keyup', handleKeyUp);
                }
            }
        };
    }, [onChange, onKeyUp]);


    return (
        <>
            {isLoading && <CircularLoader pageCentered={true} displayInElement={true} spacing={true}/>}
            {isError && <ElementTag className="ch-content-error">There was an error loading MathJax content.</ElementTag>}
            <ElementTag className={"ch-mathjax-content"} {...rest} ref={divRef} dangerouslySetInnerHTML={{__html: html}}></ElementTag>
        </>
    );
};

export default MathJaxHTMLContent;